document.addEventListener('DOMContentLoaded', function() {    
    function setupMobileCurrencySelector() {
      const mobileMenu = document.querySelector('.mobile-sidebar');
      const currencySelector = document.querySelector('.currency-selector-wrapper');
      const mobileCurrencyContainer = document.getElementById('mobile-currency-selector');
      
      
      if (mobileMenu && currencySelector && mobileCurrencyContainer) {
        if (!mobileCurrencyContainer.querySelector('.mobile-version')) {
          const mobileSelector = currencySelector.cloneNode(true);
          mobileSelector.classList.add('mobile-version');
          mobileCurrencyContainer.appendChild(mobileSelector);
        }
        
        currencySelector.classList.add('desktop-version');
      }
    }
    
    function initializeCurrencySelectors() {
      const currencySelectors = document.querySelectorAll('.currency-selector-wrapper');      
      currencySelectors.forEach((selector, index) => {
        const selectedCurrency = selector.querySelector('.selected-currency');
        const dropdown = selector.querySelector('.currency-dropdown');
        const options = selector.querySelectorAll('.currency-option');
        
        if (!selectedCurrency || !dropdown || options.length === 0) {
          console.warn('Missing required elements in selector', index + 1);
          return;
        }
        
        const newSelectedCurrency = selectedCurrency.cloneNode(true);
        selectedCurrency.parentNode.replaceChild(newSelectedCurrency, selectedCurrency);
        
        newSelectedCurrency.addEventListener('click', (e) => {
          e.stopPropagation();
          const isExpanded = newSelectedCurrency.getAttribute('aria-expanded') === 'true';
          newSelectedCurrency.setAttribute('aria-expanded', !isExpanded);
          dropdown.classList.toggle('show');
        });
        
        options.forEach((option, optionIndex) => {
          const newOption = option.cloneNode(true);
          option.parentNode.replaceChild(newOption, option);
          
          newOption.addEventListener('click', (e) => {
            e.stopPropagation();
            
            const currency = newOption.getAttribute('data-currency');
            const symbol = newOption.getAttribute('data-symbol');
            
            if (!currency || !symbol) {
              console.error('Missing currency data attributes');
              return;
            }
            
            document.querySelectorAll('.currency-selector-wrapper').forEach(sel => {
              const currencyCode = sel.querySelector('.currency-code');
              const currencySymbol = sel.querySelector('.currency-symbol');
              const selDropdown = sel.querySelector('.currency-dropdown');
              const selSelectedCurrency = sel.querySelector('.selected-currency');
              
              if (currencyCode) currencyCode.textContent = currency;
              if (currencySymbol) currencySymbol.textContent = `(${symbol})`;
              
              sel.querySelectorAll('.currency-option').forEach(opt => opt.classList.remove('active'));
              const activeOption = sel.querySelector(`.currency-option[data-currency="${currency}"]`);
              if (activeOption) activeOption.classList.add('active');
              
              if (selDropdown) selDropdown.classList.remove('show');
              if (selSelectedCurrency) selSelectedCurrency.setAttribute('aria-expanded', 'false');
            });
                        
            document.dispatchEvent(new CustomEvent('currencyChanged', {
              detail: { currency, symbol }
            }));
            
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('currency', currency);
            window.location.href = currentUrl.toString();
          });
          
          newOption.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              newOption.click();
            }
          });
        });
        
        const outsideClickHandler = (e) => {
          if (!selector.contains(e.target)) {
            dropdown.classList.remove('show');
            newSelectedCurrency.setAttribute('aria-expanded', 'false');
          }
        };
        
        if (selector.outsideClickHandler) {
          document.removeEventListener('click', selector.outsideClickHandler);
        }
        document.addEventListener('click', outsideClickHandler);
        selector.outsideClickHandler = outsideClickHandler;
        
        const escapeKeyHandler = (e) => {
          if (e.key === 'Escape') {
            dropdown.classList.remove('show');
            newSelectedCurrency.setAttribute('aria-expanded', 'false');
            newSelectedCurrency.focus();
          }
        };
        
        if (selector.escapeKeyHandler) {
          document.removeEventListener('keydown', selector.escapeKeyHandler);
        }
        document.addEventListener('keydown', escapeKeyHandler);
        selector.escapeKeyHandler = escapeKeyHandler;
      });
    }
    
    setupMobileCurrencySelector();
    initializeCurrencySelectors();
    
    document.addEventListener('mobileMenuOpened', initializeCurrencySelectors);
  });